/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import store from './store'
import moment from 'moment'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  getRoles({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'user_role'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getTicketStatus({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'ticket_status'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },


  getProducts({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'product'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getProjects({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'project'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getCompanies({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'companies'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getSdkUsers({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'user_list_sdk_download'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getRolesList({ commit }, pageDetails) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', pageDetails)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },


  getSettings({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'settings'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getTypes({ commit }, payload) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', payload)
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getDeviceFamily({ commit }, payload) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', payload)
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getAreas({ commit }, payload) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', payload)
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getuser_status({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'user_status'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getusers({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/list', postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => { reject(error.response.data.result.message) })
    })
  },

  get_user_token_details({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/validate-email', postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error.response.data.result);
        })
    })
  },

  get_recent_settings({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/get-recent-settings', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },

  userCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/create', postdata.userDetails)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })

  },

  roleCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/masterdata/add', postdata.userDetails)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },


  projectCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/masterdata/add', postdata.details)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  roleUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/masterdata/update', postdata.userDetails)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },
  
  clearCatche({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/masterdata/delete-cache', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },
  projectUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/masterdata/update', postdata.details)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },

  getUserDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/details', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  getTicketDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/details', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  userUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/update', postdata.userDetails)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  changePassword({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/change-password', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message.message
          reject(dt)
        })
    })
  },

  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', { userRole: payload.userRole })
  },
  getSdkList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  getSdkAnalytics({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/get-downloaded-history', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  //license-agreement/get-history
  getAgreementHistory({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/get-history', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  getSdkVersionsList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/version-list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  uploadSdk({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  sdkDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/details', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },
  updateSdk({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/update', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  publishAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/publish', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },

  DocumentList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  DocumentCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  ticketCommentCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/add-comment', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error
          reject(dt)

        })
    })
  },
  //http://localhost:8989/support-tickets/update-comment
  jiracommentCommentCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/update-comment', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error
          reject(dt)

        })
    })
  },

  DocumentDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/details', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {

          const dt = error.response.data.result.error
          reject(dt)
        })
    })
  },
  DocumentUpdate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/update', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  uploadS3File({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("/s3/upload", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },
  uploadLocalFiless({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("common/local-upload", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },

  //common/local-upload
  
  uploadingFilesss({ commit }, postdata) {
    console.log(commit)
    return new Promise((resolve) => {
      axios.post("support-tickets/import", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },
  commonAction({commit}, {data ,path=""}) {
    return new Promise((resolve, reject) => {
        axios.post(path, data)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);
        })
    })
  },


  knowledgebaseList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  knowledgeBaseCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  knowledgeBaseDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/details', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {

          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },
  knowledgeBaseUpdate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/knowledge-base/update', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  uploadS3File({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("/s3/upload", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },

  getSignedUrl({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("s3/get-signed-url", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },

  getTicketList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  exportTicketList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('support-tickets/export', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  getTicketsListForExport({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/export', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },

  getTicketCommentList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/comment-list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },

  supportTicketCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  supportTicketUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/update', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  updateTicketwithDefaultCompany({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/updateticket-default-company', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },

  updateTicketStatus({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/update-status', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },

  getEmployeeList({ commit }) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', {
        page: 1,
        perpage: 1000,
        category: 'employee_list'
      })
        .then((response) => {
          resolve(response.data.result.list)
        })
        .catch((error) => {
          reject(error.response.data.result.error.error)
        })
    })
  },

  assignEmployees({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/assign-employee', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  getTicketStats({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/dashboard-stats', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },

  //license-agreement/create
  addLicenceAgreement({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },
  getTermsAndCondationList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          //const dt =  error.response.data.result
          resolve(error)

        })
    })

  },
  //license-agreement/details
  getLicenceAgreement({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/details', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error
          reject(dt)
        })
    })
  },


  getRecent({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/get-recent', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error
          reject(dt)
        })
    })
  },
  //check-license-agree
  checkLicenseAgree({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/check-license-agree', postdata)
        .then((response) => {

          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error
          reject(dt)
        })
    })
  },

  updateLicenceAgreement({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/update', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },
  //updateTermsandCondationStatus
  updateTermsandCondationStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/license-agreement/activate', payload)
        .then(response => {

          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result)
        }
        )
    })
  },

  //s3/list,
  getsdkBucketList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/s3/list', postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => { reject(error.response.data.result.error.message) })
    })
  },

  getSupportTicketSummary({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/dashboard/support-ticket-summary', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },
  activateJira({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/jira/authorize', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },

  //transforToJira
  transforToJira({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/support-tickets/transfer-to-jira', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },

  //
  getCustomersSummary({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/dashboard/customer-summary', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })
  },

  getProjectsList({ commit }, params) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', params)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getMasterData({ commit }, params) {
    return new Promise((resolve) => {
      axios.post('/masterdata/list', params)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  getClientsList({ commit }, pageDetails) {
    return new Promise((resolve) => {
      axios.post('/company/list', pageDetails)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.result.error_message)
        })
    })
  },

  clientDefaultVal({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/company/update-last-login-check-days', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  getMailContent({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sdk/get-publish-email-content', postdata)
        .then((response) => {
          const dt = response.data.result;
          //alert(dt)
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },


  //users/customers-list
  getCcustomersList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/customers-list', postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => { reject(error.response.data.result.message) })
    })
  },

  
  setNotification({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/users/manage-notification', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)
        })
    })
  },

  getjiraAccountDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/jira/get-user-details', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },

  getDominList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/domain-config/list', postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => { reject(error.response.data.result.message) })
    })
  },

  domainConfigCreate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('domain-config/create', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },

  domainConfigUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/domain-config/update', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },
  
  deleteDomainConfig({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/domain-config/delete', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result.error_message
          reject(dt)

        })
    })
  },
  getSentEmailsList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sent-emails/list', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt = error.response.data.result
          reject(dt)

        })
    })

  },
  getMailContant({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/sent-emails/get-sent-html', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt =  error.response.data.result
          reject(dt)

        })
    })

  },
  getTokenDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/get-token-details', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt =  error.response.data.result
          reject(dt)

        })
    })

  },
  updateCompanyStatus({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post('/company/update-status', postdata)
        .then((response) => {
          const dt = response.data.result
          resolve(dt)
        })
        .catch((error) => {
          const dt =  error.response.data.result
          reject(dt)

        })
    })

  },
  



}

export default actions
